import { labelClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const GetStartedBtn: StyleRule = ({ theme }) => ({
    width: pxToRem(378),
    height: pxToRem(50),
    [`& .${labelClassName}`]: {
        fontSize: pxToRem(13),
        width: pxToRem(99),
        marginLeft: pxToRem(-2),
    },
    [`& > span`]: {
        margin: 0,
        padding: 0,
        [`& .${svgIconClassName}`]: {
            padding: pxArrayToRem([1, 0, 0, 1]),
            width: pxToRem(24),
            height: pxToRem(24),
            '& path': {
                fill: 'white',
            },
        },
    },

    [theme.screen.tablet]: {
        position: 'relative',
        marginTop: pxToRem(30),
        width: pxToRem(138),
        height: pxToRem(44),
        [`& .${labelClassName}`]: {
            fontSize: pxToRem(14),
            width: 'unset',
            marginLeft: 'inherit',
            whiteSpace: 'nowrap',
        },
    },
});
